<template>
  <v-data-table
    dense
    :headers="headers"
    :items="data"
    class="elevation-1"
    :mobile-breakpoint="0"
  >
    <!-- <template v-slot:item.google_maps="{ item }">
      <v-btn
        color="primary"
        text
        v-bind="attrs"
        @click="openGoogleMaps(item)"
      >
        ดูแผนที่
      </v-btn>
    </template> -->
  </v-data-table>
</template>

<script>
export default {
  props: {
    data: Object,
  },

  data() {
    return {
      headers: [
        // {
        //   text: 'SKU',
        //   align: 'start',
        //   sortable: false,
        //   value: 'sku',
        // },
        { text: 'ชื่อ', value: 'name', sortable: false },
        { text: 'จำนวน', value: 'amount' },
        { text: 'สาขา', value: 'branch_name', sortable: false },
        { text: 'PO', value: 'estimate_date' },
        { text: 'action', value: 'google_maps', sortable: false },
      ],

      items: [
        {
          sku: '4777711122212',
          product_name: 'iPhone 14 Pro Max 128GB',
          brand: 'Apple',
          available_stock: 24,
          online_stock: 4,
          offline_stock: 2,
          total_stock: 30,
          reserved_stock: 6,
          commited_stock: 0,
        },
        {
          sku: '4777711122213',
          product_name: 'iPhone 14 Pro Max 256GB',
          brand: 'Apple',
          available_stock: 22,
          online_stock: 5,
          offline_stock: 2,
          total_stock: 32,
          reserved_stock: 6,
          commited_stock: 3,
        },
      ],
    }
  },

  methods: {
    openGoogleMaps(item) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${item.lat},${item.lng}`,
        '_blank',
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
::v-deep .v-data-table
  overflow-x: auto;
</style>
